import { FaChevronRight, FaHandPaper } from "react-icons/fa";

const ClaimBanner = ({ onClick }) => {
  return (
    <button
      type="button"
      onClick={onClick}
      className="leaderboard-claim-banner group"
      aria-label="Go to slap generator"
    >
      <div className="leaderboard-claim-copy">
        <span className="leaderboard-claim-icon">
          <FaHandPaper className="h-5 w-5" />
        </span>
        <div>
          <p className="leaderboard-claim-title">Keep climbing</p>
          <p className="leaderboard-claim-subtitle">
            Claim your daily slaps to boost your rank.
          </p>
        </div>
      </div>
      <FaChevronRight className="leaderboard-claim-arrow" />
    </button>
  );
};

export default ClaimBanner;

